import { type Dictionary, groupBy } from 'lodash';

import { getToolCopy, getToolTitle } from 'src/data/generationTool';

import { PROMPT_SUB_TEMPLATE_ID } from './const';
import type { TemplateTag } from './tags';
import type { GenericOrSubTemplate, GenericTemplate, SubTemplate } from './types';

export const mergeGenericAndSubTemplates = (
  genericTemplates: GenericTemplate[],
  subTemplates: SubTemplate[]
) => {
  const groupedSubTemplates = groupBy(subTemplates, 'generationTool');
  return genericTemplates.flatMap((template) => mergeSubTemplates(template, groupedSubTemplates));
};

export const filterTemplatesByTag = (
  templates: GenericOrSubTemplate[],
  tag: TemplateTag
): GenericOrSubTemplate[] => {
  return templates.filter((template) => template.tags.includes(tag));
};

const mergeSubTemplates = (
  template: GenericTemplate,
  groupedSubTemplates: Dictionary<SubTemplate[]>
): GenericOrSubTemplate[] => {
  const toolSubTemplates = groupedSubTemplates[template.generationTool];
  if (!Array.isArray(toolSubTemplates) || toolSubTemplates.length === 0) {
    return [template];
  }

  const prompt = {
    ...template,
    subTemplateData: {
      id: PROMPT_SUB_TEMPLATE_ID,
      tool: template.generationTool,
      name: `${getToolTitle(template.generationTool)} - Prompt`,
      description: getToolCopy(template.generationTool),
    },
  };

  return [prompt, ...toolSubTemplates];
};
